export default __webpack_public_path__ + "static/blob5-fcbf314d99b875b5b0f54165a53d69f1.svg";